import api from '../apiService';
import { populateFields, clearFields, propSpinner, disableSaveButton, createDebouncedMemoRequest } from '../utils';

const debounceSearch = createDebouncedMemoRequest(api.getData, 300);

export async function fetchIstatRegion(provinceField, regionField) {
    const provinceSigla = $('select[name="' + provinceField + '"]').val();
    if (!provinceSigla) {
        clearFields([regionField]);
        return;
    }

    propSpinner([regionField], true);
    disableSaveButton(true);

    const cacheKey = `${provinceField}-${regionField}-${provinceSigla}`;

    debounceSearch(cacheKey, `/api/app/backpack/fetch-istat-region`, {
        params: {
            sigla: provinceSigla
        },
    }).then((data) => {
        if (data.region) {
            populateFields({[regionField]: data.region});
        }
    }).catch(() => {
        clearFields([regionField]);
    }).finally(() => {
        propSpinner([regionField], false);
        disableSaveButton(false);
    });
}
